import { initPostHog } from "./posthog";

initPostHog();
